import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";

const FeeManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "white",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    padding: "18px 20px",
    display: "flex",
    alignItems: "center",
    gap: "18px",
    cursor: "pointer",
    transition: "0.2s",
    minHeight: "120px",
    height: "100%",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subheading = {
    fontSize: "12px",
    opacity: 0.7,
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div style={{ background: "#ffffff", minHeight: "100vh" }} className="flex justify-center items-start p-6">
      <div className="w-full max-w-7xl">

       

        {/* Grid: 3 columns desktop, 1 mobile */}
        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`} style={{ alignItems: "stretch" }}>

          {/* Fee Collection */}
          <Link to="/fee-collection" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-money-bill" style={{ ...iconStyle, color: "#10B981" }}></i>
              <div>
                <h2 style={heading}>Fee Collection</h2>
                <p style={subheading}>View fee collection.</p>
              </div>
            </div>
          </Link>

          {/* Fee Structure */}
          <Link to="/fee-list" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-folder-tree" style={{ ...iconStyle, color: "#F59E0B" }}></i>
              <div>
                <h2 style={heading}>Fee Structure</h2>
                <p style={subheading}>View fee structure.</p>
              </div>
            </div>
          </Link>

          {/* Fee Heads */}
          <Link to="/fee-heads" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-file-invoice" style={{ ...iconStyle, color: "#3B82F6" }}></i>
              <div>
                <h2 style={heading}>Fee Heads</h2>
                <p style={subheading}>View fee heads.</p>
              </div>
            </div>
          </Link>

          {/* Student Ledgers */}
          <Link to="/student-ledgers" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-book" style={{ ...iconStyle, color: "#8B5CF6" }}></i>
              <div>
                <h2 style={heading}>Student Ledgers</h2>
                <p style={subheading}>View student ledgers.</p>
              </div>
            </div>
          </Link>

          <Link to="/concession-heads" className="flex">
  <div style={cardStyle} className="hover:scale-[1.01] w-full">
    <i className="fas fa-percent" style={{ ...iconStyle, color: "#10B981" }}></i>
    <div>
      <h2 style={heading}>Concession Heads</h2>
      <p style={subheading}>Manage concession heads.</p>
    </div>
  </div>
</Link>


        </div>
      </div>
    </div>
  );
};

export default FeeManagement;
